import React from "react";
import PropTypes from "prop-types";

import UndoAttempt from "./img/undo-icon-active.svg";
import UndoAttemptUsed from "./img/undo-icon-disabled.svg";

import "./style.scss";

export class Undo extends React.Component {

  undoClicked = () => {
   this.props.setModal({
     display: true,
     type: "UNDO",
     size: "xs",
     connect: -1
   });
  }

  getAttempts = () => {
    let attempts = [];

    for (
      let i = 0;
      i < (this.props.undoAttempts > 3 ? 3 : this.props.undoAttempts);
      i++
    ) {
      //Add attemps left image
      attempts.push(
        <img
          alt="Available undo icon"
          src={UndoAttempt}
          class="undoAttemptImg"
        />
      );
    }
    for (
      let i = 0;
      i < (this.props.undoAttempts > 3 ? 0 : 3 - this.props.undoAttempts);
      i++
    ) {
      //Add attempts used image
      attempts.push(
        <img
          alt="Disabled undo icon"
          src={UndoAttemptUsed}
          class="undoAttemptImg"
        />
      );
    }

    return attempts;
  };

  render() {
    return (
      <div id="undo" className="undoDiv">
        <button className="undoBtn" tabIndex="0" onClick={this.undoClicked}>
          Restart step
        </button>
        {this.getAttempts()}
      </div>
    );
  }
}

Undo.propTypes = {
  scale: PropTypes.number,
  scaleUp: PropTypes.func,
  scaleDown: PropTypes.func,
};
